<div class="login-shell">
  <div class="login-card">
    <div class="login-brand">
      <img src="/assets/login-logo.png" alt="Logo Bussify" class="login-logo" />
    </div>

    @if (authStore.isLoggedIn()) {
      <div class="login-copy">
        <h1>Jesteś już zalogowany</h1>
        <p>Możesz wrócić do aplikacji albo przejść dalej do pulpitu.</p>
      </div>

      <p-button
        label="Przejdź do aplikacji"
        icon="pi pi-arrow-right"
        styleClass="login-button"
        (onClick)="goBack()"
      ></p-button>
    } @else if (isLocalAuth) {
      <div class="login-copy">
        <h1>Zaloguj się lokalnie</h1>
        <p>
          Użyj lokalnego konta testowego, aby wejść do aplikacji bez Auth0 i bez dostępu do sieci.
        </p>
      </div>

      <app-login-form
        [isLoaded]="isSubmitting()"
        (submitted)="loginLocal($event)"
      ></app-login-form>

      @if (isSubmitting()) {
        <p class="login-redirect-hint">Trwa logowanie lokalne...</p>
      }
    } @else {
      <div class="login-copy">
        <h1>Zaloguj się przez Auth0</h1>
        <p>
          Użyj konta Auth0, aby wejść do aplikacji i wrócić dokładnie tam, gdzie przerwałeś.
        </p>
      </div>

      <p-button
        [label]="isRedirecting() ? 'Przekierowywanie...' : 'Przejdź do logowania'"
        [icon]="isRedirecting() ? 'pi pi-spinner pi-spin' : 'pi pi-arrow-right'"
        [loading]="isRedirecting()"
        [disabled]="isRedirecting()"
        styleClass="login-button"
        (onClick)="loginWithRedirect()"
      ></p-button>

      @if (isRedirecting()) {
        <p class="login-redirect-hint">Za chwilę otworzy się ekran logowania Auth0.</p>
      }
    }

    @if (authStore.authError()) {
      <div class="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
        {{ authStore.authError() }}
      </div>
    }
  </div>
</div>
